import { render, staticRenderFns } from "./product-inline-list-loader.vue?vue&type=template&id=94b7edd4&scoped=true"
import script from "./product-inline-list-loader.vue?vue&type=script&lang=js"
export * from "./product-inline-list-loader.vue?vue&type=script&lang=js"
import style0 from "./product-inline-list-loader.vue?vue&type=style&index=0&id=94b7edd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b7edd4",
  null
  
)

export default component.exports